import { INITIAL_LOAD } from './actions';

export function AnalyticsDetails(state = {}, action = { type: null }) {
  if (action.type === INITIAL_LOAD) {
    const newState = Object.assign(action.analyticsDetails);
    return newState;
  }
  return state;
}
